import SelectField from '../../../select-field';
import { FilterComponentProps } from '../../types';

export function BooleanFilter<I extends EntityBase = EntityBase>(props: Pick<FilterComponentProps<I>, 
  'filter' | 'onChange'>) {
  const {
    filter,
    onChange,
  } = props;
  return <SelectField 
    id={filter.name.toString()} 
    label={filter.label} 
    value={filter.value === '1' 
      ? BooleanFilterOptions[1] 
      : filter.value === '0'
        ?  BooleanFilterOptions[0] : undefined}   
    options={BooleanFilterOptions}
    onChange={(value) => {
        onChange({
          ...filter,
          value: value?.id.toString(),
        });
      }}
  />;
}

const BooleanFilterOptions = [
  { id: 0, name: 'Нет' },
  { id: 1, name: 'Да' },
];